<template>
    <el-container class="ysxkShowmorexx">
        <el-main>
            <el-breadcrumb separator-class="el-icon-arrow-right" >
                <el-breadcrumb-item class="headTitle">当前位置：</el-breadcrumb-item>
                <el-breadcrumb-item class="secondTitle">商品房</el-breadcrumb-item>
                <el-breadcrumb-item class="ThirdTitle">预售项目详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="mainCard">
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">开发企业状况</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    企业名称：
                                </span>
                            <span class="Spancontent2">
                                    {{kfqyList.QYMC}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    法人代表：
                                </span>
                            <span class="Spancontent2">
                                    {{kfqyList.FRDB}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    企业地址：
                                </span>
                            <span class="Spancontent2">
                                    {{kfqyList.QYDZ}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    联系电话：
                                </span>
                            <span class="Spancontent2">
                                    {{kfqyList.LXDH}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    资质证号：
                                </span>
                            <span class="Spancontent2">
                                    {{kfqyList.ZZZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    资质有效期：
                                </span>
                            <span class="Spancontent2">
                                    {{kfqyList.ZZYXQ}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">预售项目情况</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    项目名称：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.XMMC}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    所属区域：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.SSQY}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    预售面积(㎡)/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.YSMJTS}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    住宅面积(㎡)/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.ZZMJTS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    商业面积(㎡)/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.SYMJTS}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    车库面积(㎡)/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.CKMJTS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    办公面积(㎡)/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.BGMJTS}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    其他面积(㎡)/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.QTMJTS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    项目地址：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxmqkList.XMDZ}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">资金监管信息</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    资金监管银行：
                                </span>
                            <span class="Spancontent2">
                                    {{zjjgxxList.ZJJGYH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    资金监管账号：
                                </span>
                            <span class="Spancontent2">
                                    {{zjjgxxList.ZJJGZH}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div >
                            <span class="headSecond">
                                预售销控情况
                            </span>
                            <span class="headThird">
                                (点击对应楼号可查询预售房屋网签、备案、查封等即时状态)
                            </span>
                        </div>
                    </div>
                    <el-row>
                        <el-col>
                                <span class="Spancontent1">
                                    预售楼号：
                                </span>
                            <span class="Spancontent2">
                                    <el-button plain class="lpbButton" v-for="item in yslpList" @click="OpenLpbXx(item.buildid)">
                                                {{item.lh}}
                                    </el-button>
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">土地使用权证信息</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地使用权证号：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDSYQZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地使用权面积(㎡)：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDSYQMJ}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地批准用途：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDPZYT}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地取得方式：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDQDFS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地使用权起始日期：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDSYQQSRQ}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地使用权终止日期：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDSYQZZRQ}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    土地使用权发证日期：
                                </span>
                            <span class="Spancontent2">
                                    {{tdsyqzList.TDSYQFZRQ}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">建设用地规划许可信息</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    建设用地规划许可证号：
                                </span>
                            <span class="Spancontent2">
                                    {{jsydList.JZYDGHXKZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    建设规模(㎡)：
                                </span>
                            <span class="Spancontent2">
                                    {{jsydList.JZGM}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    用地面积(㎡)：
                                </span>
                            <span class="Spancontent2">
                                    {{jsydList.YDMJ}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    发证日期：
                                </span>
                            <span class="Spancontent2">
                                    {{jsydList.FZRQ}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">工程规划许可信息</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    工程规划许可证号：
                                </span>
                            <span class="Spancontent2">
                                    {{gcghList.GCGHXKZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    建设面积(㎡)：
                                </span>
                            <span class="Spancontent2">
                                    {{gcghList.JSMJ}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    容积率(%)：
                                </span>
                            <span class="Spancontent2">
                                    {{gcghList.RJL}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    绿化率(%)：
                                </span>
                            <span class="Spancontent2">
                                    {{gcghList.LHL}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    发证日期：
                                </span>
                            <span class="Spancontent2">
                                    {{gcghList.FZRQ}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">施工许可证信息</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    施工许可证号：
                                </span>
                            <span class="Spancontent2">
                                    {{sgxkList.SGXKZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    开工日期：
                                </span>
                            <span class="Spancontent2">
                                    {{sgxkList.KGRQ}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    竣工日期：
                                </span>
                            <span class="Spancontent2">
                                    {{sgxkList.JGRQ}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    发证日期：
                                </span>
                            <span class="Spancontent2">
                                    {{sgxkList.FZRQ}}
                                </span>
                        </el-col>
                    </el-row>
<!--                    <el-row>-->
<!--                        <el-col :span="12">-->
<!--                                <span class="Spancontent1">-->
<!--                                    发证日期：-->
<!--                                </span>-->
<!--                            <span class="Spancontent2">-->
<!--                                    {{sgxkList.FZRQ}}-->
<!--                                </span>-->
<!--                        </el-col>-->
<!--                    </el-row>-->
                </el-card>
                <el-card class="box-card" shadow="never">
                    <div slot="header" class="clearfix">
                        <div class="headFirst"></div>
                        <div class="headSecond">预售许可证信息</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    预售证号：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxkxxList.YSXKZH}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    商业面积/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxkxxList.SYMJTS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    预售面积/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxkxxList.YSMJTS}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    车库面积/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxkxxList.CKMJTS}}
                                </span>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    住宅面积/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxkxxList.ZZMJTS}}
                                </span>
                        </el-col>
                        <el-col :span="12">
                                <span class="Spancontent1">
                                    办公面积/套数：
                                </span>
                            <span class="Spancontent2">
                                    {{ysxkxxList.BGMJTS}}
                                </span>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import {mapActions} from "vuex";
	import axios from 'axios';
	import config from "@/config";
	const base_url = config.baseUrl + 'spf/';

    export default {
        name: "ysxkshowmoreXx",
        data() {
            return {
				xkzh: null,
                kfqyList:{
                    QYMC:'某某公司',
                    FRDB:'张珊珊',
                    QYDZ:'莫某地方三角带黄金区',
                    LXDH:'12383282323',
                    ZZZH:'123EWDSSD2112',
                    ZZYXQ:'2020-12-12'
                },
                ysxmqkList:[],
                zjjgxxList:[],
                yslpList:[
                    {lh:'1号楼',buildid:2},
                    {lh:'2号楼',buildid:2},
                    {lh:'3号楼',buildid:2},
                    {lh:'4号楼',buildid:2},
                    {lh:'5号楼',buildid:2},
                ],
                tdsyqzList:[],
                jsydList:[],
                gcghList:[],
                sgxkList:[],
                ysxkxxList:[],
            }
        },
        methods: {
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            OpenLpbXx(buildid){
                this.$router.push({path:'/ywhome/spfhome/lpbXx',query:{roomid:buildid}})
            },
        },
        created() {
			this.xkzh = this.$route.query.xssx;
			// 预售许可详细信息
			axios.get(base_url + "ysxkxxxx" + "?xkzh=" + this.xkzh).then(response => {
				if (response.data.kfqyList.length) this.kfqyList = response.data.kfqyList[0];
				if (response.data.ysxmqkList.length) this.ysxmqkList = response.data.ysxmqkList[0];
				if (response.data.zjjgxxList.length) this.zjjgxxList = response.data.zjjgxxList[0];
				this.yslpList = response.data.yslpList;
				if (response.data.tdsyqzList.length) this.tdsyqzList = response.data.tdsyqzList[0];
				if (response.data.jsydList.length) this.jsydList = response.data.jsydList[0];
				if (response.data.gcghList.length) this.gcghList = response.data.gcghList[0];
				if (response.data.sgxkList.length) this.sgxkList = response.data.sgxkList[0];
				if (response.data.ysxkxxList.length) this.ysxkxxList = response.data.ysxkxxList[0];
			}).catch(error => console.log(error, "error"));
        }
    }
</script>

<style scoped>
    @import "../assets/css/spf/spfmorexx.css";
</style>